// DO NOT set the `name` and `ticker` properties manually
// Instead use one of the get token metadata scripts https://github.com/ExodusMovement/exodus-core/tree/master/packages/assets-base#get-token-metadata

export default [
  {
    name: '1inch_bsc_61c44543',
    displayName: '1inch Network',
    decimals: 18,
    ticker: '1INCHbsc61C44543',
    displayTicker: '1INCH',
    addresses: { current: '0x111111111117dC0aa78b770fA6A738034120C302' },
    tokenType: 'BEP20',
    info: {
      description:
        ' 1Inch is an exchange aggregator, meaning that it scans various decentralized exchanges to locate the lowest crypto price for traders.',
      reddit: 'https://reddit.com/r/1inch',
      twitter: 'https://twitter.com/1inch',
      website: 'https://1inch.io/',
    },
    primaryColor: '#2f79ea',
    gradientColors: ['#2F79EA', '#124282'],
    gradientCoords: { x1: '0%', y1: '0%', x2: '100%', y2: '100%' },
  },
  {
    name: 'ada_bsc_db5f96ab',
    displayName: 'Cardano',
    decimals: 18,
    ticker: 'ADAbscDB5F96AB',
    displayTicker: 'ADA',
    addresses: {
      current: '0x3EE2200Efb3400fAbB9AacF31297cBdD1d435D47',
    },
    info: {
      description:
        'Cardano is an open source project and decentralized public blockchain. It is building a smart contract platform and uses a proof of stake algorithm to reach consensus about the network.',
      reddit: 'https://www.reddit.com/r/cardano/',
      twitter: 'https://twitter.com/cardano',
      website: 'https://www.cardano.org/',
      telegram: 'https://t.me/CardanoAnnouncements',
    },
    primaryColor: '#4A6EC3',
    gradientColors: ['#4A6EC3', '#3384BF'],
    gradientCoords: { x1: '106.38%', y1: '115.934%', x2: '-33.63%', y2: '-54.191%' },
    tokenType: 'BEP20',
  },
  {
    name: 'alice_bsc_06579e0c',
    displayName: 'MyNeighborAlice',
    decimals: 6,
    ticker: 'ALICEbsc06579E0C',
    displayTicker: 'ALICE',
    addresses: { current: '0xAC51066d7bEC65Dc4589368da368b212745d63E8' },
    tokenType: 'BEP20',
    info: {
      description:
        'ALICE is the native currency in the farming game My Neighbor Alice and is used for purchases, staking, governance, and participation rewards. The game is expansive and multiplayer, with virtual real estate, gamified finance, and competitions.',
      reddit: 'https://reddit.com/r/MyNeighborAlice',
      twitter: 'https://twitter.com/MyNeighborAlice',
      website: 'https://www.myneighboralice.com/',
    },
    primaryColor: '#F3E9DC',
    gradientColors: ['#F3E9DC', '#F3E9DC'],
    gradientCoords: { x1: '29%', y1: '34.5%', x2: '-1%', y2: '-6.5%' },
  },
  {
    name: 'alpaca_bsc_5a5767ef',
    displayName: 'Alpaca Finance',
    decimals: 18,
    ticker: 'ALPACAbsc5A5767EF',
    displayTicker: 'ALPACA',
    addresses: { current: '0x8F0528cE5eF7B51152A59745bEfDD91D97091d2F' },
    tokenType: 'BEP20',
    info: {
      description:
        'The ALPACA token powers Alpaca Finance, a community-owned lending protocol. Users can lend tokens and earn interest, or open a leveraged yield farming position through borrowing.',
      twitter: 'https://twitter.com/AlpacaFinance',
      website: 'https://www.alpacafinance.org/',
    },
    primaryColor: '#2DEA8F',
    gradientColors: ['#1FA967', '#2DEA8F'],
    gradientCoords: { x1: '0%', y1: '0%', x2: '102%', y2: '101%' },
  },
  {
    name: 'avax_bsc_6383077e',
    displayName: 'Avalanche',
    decimals: 18,
    ticker: 'AVAXbsc6383077E',
    displayTicker: 'AVAX',
    addresses: {
      current: '0x1CE0c2827e2eF14D5C4f29a091d735A204794041',
    },
    info: {
      description:
        'Avalanche is an open-source platform for launching decentralized finance applications and enterprise blockchain deployments in one interoperable, highly scalable ecosystem. It is a smart contract-capable blockchain platform focused on transaction speed, low costs, and eco-friendliness.',
      reddit: 'https://www.reddit.com/r/Avax',
      twitter: 'https://twitter.com/AvalancheAVAX',
      website: 'https://www.avax.network/',
      telegram: 'https://t.me/avalancheavax',
      medium: 'https://medium.com/avalancheavax',
    },
    primaryColor: '#FE7C7D',
    gradientColors: ['#E84142', '#FE7C7D'],
    gradientCoords: { x1: '-3.98%', y1: '1.381%', x2: '49.273%', y2: '30.414%' },
    tokenType: 'BEP20',
  },
  {
    name: 'bnx_bsc_08fb5f48',
    displayName: 'BinaryX',
    decimals: 18,
    ticker: 'BNXbsc08FB5F48',
    displayTicker: 'BNX',
    addresses: { current: '0x5b1f874d0b0c5ee17a495cbb70ab8bf64107a3bd' },
    tokenType: 'BEP20',
    info: {
      description:
        'BNX is the platform cryptocurrency powering the BinaryX ecosystem, a GameFi platform that provides infra support such as Initial Game Offering (IGO) services to Web3 game developers.',
      twitter: 'https://twitter.com/binary_x',
      website: 'https://binaryx.pro/',
    },
    primaryColor: '#F15F40',
    gradientColors: ['#F6465D', '#F15F40'],
    gradientCoords: { x1: '0%', y1: '0%', x2: '102%', y2: '101%' },
  },
  {
    name: 'brise_bsc_41a56649',
    displayName: 'Bitgert',
    decimals: 9,
    ticker: 'BRISEbsc41A56649',
    displayTicker: 'BRISE',
    addresses: { current: '0x8FFf93E810a2eDaaFc326eDEE51071DA9d398E83' },
    tokenType: 'BEP20',
    info: {
      description:
        'BRISE is the native token for Brise Chain, a fast and cheap EVM-compatible blockchain with an ecosystem supporting DeFi, NFTs, a metaverse, and more.',
      twitter: 'https://twitter.com/bitgertbrise',
      website: 'https://bitgert.com/',
      telegram: 'https://t.me/bitgertbrise',
    },
    primaryColor: '#AC53FF',
    gradientColors: ['#7E0BE8', '#AC53FF'],
    gradientCoords: { x1: '0%', y1: '0%', x2: '100%', y2: '100%' },
  },
  {
    name: 'bsw_bsc_1af7c444',
    displayName: 'Biswap',
    decimals: 18,
    ticker: 'BSWbsc1AF7C444',
    displayTicker: 'BSW',
    addresses: { current: '0x965F527D9159dCe6288a2219DB51fc6Eef120dD1' },
    tokenType: 'BEP20',
    info: {
      description:
        'BSW is the governance token of Biswap, a low-fee, decentralized exchange on Binance Smart Chain. Biswap offers pools, farms, an NFT marketplace, IDO launchpad, and a lottery.',
      twitter: 'https://twitter.com/Biswap_DEX',
      website: 'https://biswap.org/',
    },
    primaryColor: '#5895FF',
    gradientColors: ['#1263F1', '#5895FF'],
    gradientCoords: { x1: '0%', y1: '0%', x2: '102%', y2: '101%' },
  },
  {
    name: 'busd_bsc',
    displayName: 'Binance USD',
    decimals: 18,
    ticker: 'BUSDBSC',
    displayTicker: 'BUSD',
    addresses: { current: '0xe9e7cea3dedca5984780bafc599bd69add087d56' },
    tokenType: 'BEP20',
    info: {
      description:
        'Stablecoin, issued in partnership with Binance. BUSD is 100% backed by U.S. dollars held in FDIC-insured U.S. banks.',
      twitter: 'https://twitter.com/paxosglobal',
      website: 'https://www.paxos.com/busd/',
    },
    primaryColor: '#FFC200',
    gradientColors: ['#EAEAEA', '#FFF'],
    gradientCoords: { x1: '19.031%', y1: '-66.682%', x2: '123.324%', y2: '91.487%' },
  },
  {
    name: 'celr_bsc_af903611',
    displayName: 'Celer Network',
    decimals: 18,
    ticker: 'CELRbscAF903611',
    displayTicker: 'CELR',
    addresses: { current: '0x1f9f6a696C6Fd109cD3956F45dC709d2b3902163' },
    tokenType: 'BEP20',
    info: {
      description:
        'The CELR token is used to secure Celer Network, an inter-blockchain protocol that allows apps to operate across 35+ blockchains with ease-of-use benefits such as single-click transactions.',
      twitter: 'https://twitter.com/CelerNetwork',
      website: 'https://www.celer.network/#',
    },
    primaryColor: '#C8C8C8',
    gradientColors: ['#C8C8C8', '#FFFFFF'],
    gradientCoords: { x1: '0%', y1: '0%', x2: '102%', y2: '101%' },
  },
  {
    name: 'chr_bsc_03abf483',
    displayName: 'Chromia',
    decimals: 6,
    ticker: 'CHRbsc03ABF483',
    displayTicker: 'CHR',
    addresses: {
      current: '0xf9CeC8d50f6c8ad3Fb6dcCEC577e05aA32B224FE',
    },
    tokenType: 'BEP20',
    info: {
      description:
        'CHR is the native token that powers Chromia, a platform that makes building dApps easier. Because each dApp on Chromia runs its own sidechain, developers can scale their projects easily while also maintaining unique fee structures.',
      reddit: 'https://www.reddit.com/r/Teamchromia/',
      twitter: 'https://twitter.com/Chromia',
      website: 'https://chromia.com/',
      telegram: 'https://t.me/hellochromia',
    },
    primaryColor: '#CB92F0',
    gradientColors: ['#CB92F0', '#EAC9FF'],
    gradientCoords: { x1: '0%', y1: '0%', x2: '100%', y2: '100%' },
  },
  {
    name: 'dai_bsc_709f85b7',
    displayName: 'Dai Token',
    decimals: 18,
    ticker: 'DAIbsc709F85B7',
    displayTicker: 'DAI',
    addresses: {
      current: '0x1AF3F329e8BE154074D8769D1FFa4eE058B1DBc3',
    },
    tokenType: 'BEP20',
    info: {
      description:
        'Dai is a stable, decentralized currency that does not discriminate. Any individual or business can realize the advantages of digital money.',
      twitter: 'https://twitter.com/MakerDAO',
      website: 'https://makerdao.com/en/',
      telegram: 'https://t.me/makerdaoOfficial',
    },
    primaryColor: '#FBCC5F',
    gradientColors: ['#FBCC5F', '#FBF35F'],
    gradientCoords: { x1: '0%', y1: '0%', x2: '20%', y2: '20%' },
  },
  {
    name: 'dodo_bsc_afd0876f',
    displayName: 'DODO',
    decimals: 18,
    ticker: 'DODObscAFD0876F',
    displayTicker: 'DODO',
    addresses: {
      current: '0x67ee3Cb086F8a16f34beE3ca72FAD36F7Db929e2',
    },
    tokenType: 'BEP20',
    info: {
      description:
        'DODO is the native token for the DODO DEX, which uses the Proactive Market Maker (PMM) algorithm to power its accessible DeFi services that span mining, liquidity pools, trading, and more.',
      reddit: 'https://reddit.com/r/DodoEx',
      twitter: 'https://twitter.com/BreederDodo',
      website: 'https://dodoex.io/',
    },
    primaryColor: '#FFE804',
    gradientColors: ['#FFE804', '#FFF590'],
    gradientCoords: { x1: '0%', y1: '0%', x2: '100%', y2: '100%' },
  },
  {
    name: 'eth_bsc_f1d2a904',
    displayName: 'Ethereum',
    decimals: 18,
    ticker: 'ETHbscF1D2A904',
    displayTicker: 'ETH',
    addresses: {
      current: '0x2170ed0880ac9a755fd29b2688956bd959f933f8',
    },
    tokenType: 'BEP20',
    info: {
      description:
        'Ethereum is a decentralized computing platform that runs smart contracts, which are contracts that execute without human intervention. ETH popularized the idea of using the blockchain for programmable transactions instead of only for money transfers. The platform is used for crowdfunding (ICOs), the creation of new digital assets, and more.',
      reddit: 'https://www.reddit.com/r/ethereum/',
      twitter: 'https://twitter.com/ethereum',
      website: 'https://ethereum.org/',
    },
    primaryColor: '#8C93AF',
    gradientColors: ['#474A73', '#8C93AF'],
    gradientCoords: { x1: '17.71%', y1: '-46.968%', x2: '98.837%', y2: '152.777%' },
  },
  {
    name: 'floki_bsc_c4112b36',
    displayName: 'FLOKI',
    decimals: 9,
    ticker: 'FLOKIbscC4112B36',
    displayTicker: 'FLOKI',
    addresses: {
      current: '0xfb5b838b6cfeedc2873ab27866079ac55363d37e',
    },
    tokenType: 'BEP20',
    info: {
      description:
        'Floki is a meme coin named after Elon Musk’s dog, but has expanded into a wider Floki ecosystem that includes NFTs, DeFi, and a Metaverse. It also aims to be used by charities for accepting donations.',
      reddit: 'https://reddit.com/r/Floki',
      twitter: 'https://twitter.com/RealFlokiInu',
      website: 'https://floki.com/',
    },
    primaryColor: '#FFAA5C',
    gradientColors: ['#FF4D00', '#FFAA5C'],
    gradientCoords: { x1: '0%', y1: '0%', x2: '100%', y2: '100%' },
  },
  {
    name: 'flux_bsc_2e3e61bf',
    displayName: 'Flux',
    decimals: 8,
    ticker: 'FLUXbsc2E3E61BF',
    displayTicker: 'FLUX',
    addresses: {
      current: '0xaFF9084f2374585879e8B434C399E29E80ccE635',
    },
    tokenType: 'BEP20',
    info: {
      description:
        'FLUX is a Proof-of-Work cryptocurrency that powers the Flux ecosystem, a community-run project that empowers people to use Web3 with blockchain services spanning computing, development, asset management, and more.',
      reddit: 'https://www.reddit.com/r/Flux_Official/',
      twitter: 'https://twitter.com/RunOnFlux',
      website: 'https://support.runonflux.io/support/home',
    },
    primaryColor: '#2B61D1',
    gradientColors: ['#2B61D1', '#437DF4'],
    gradientCoords: { x1: '0%', y1: '0%', x2: '100%', y2: '100%' },
  },
  {
    name: 'gal_bsc',
    displayName: 'Project Galaxy',
    decimals: 18,
    ticker: 'GALBSC',
    displayTicker: 'GAL',
    addresses: { current: '0xe4Cc45Bb5DBDA06dB6183E8bf016569f40497Aa5' },
    tokenType: 'BEP20',
    info: {
      description:
        'Project Galaxy is an expansive credential data network on the Ethereum network. It makes it easier for Web3 projects to create products using digital credentials and NFTs.',
      twitter: 'https://twitter.com/ProjectGalaxyHQ',
      website: 'https://galaxy.eco/',
      telegram: 'https://t.me/ProjectGalaxyHQ',
    },
    primaryColor: '#3671FF',
    gradientColors: ['#3671FF', '#3C49FF'],
    gradientCoords: { x1: '3%', y1: '5.5%', x2: '31%', y2: '36.5%' },
  },
  {
    name: 'gmt_bsc',
    displayName: 'STEPN',
    decimals: 8,
    ticker: 'GMTBSC',
    displayTicker: 'GMT',
    addresses: { current: '0x3019BF2a2eF8040C242C9a4c5c4BD4C81678b2A1' },
    tokenType: 'BEP20',
    info: {
      description:
        'The Green Metaverse Token is used for governance in STEPN, a gamified health app that rewards users for physical movement such as jogging outside.',
      reddit: 'https://www.reddit.com/r/StepN/',
      twitter: 'https://twitter.com/Stepnofficial',
      website: 'https://www.stepn.com/',
      telegram: 'https://t.me/STEPNannouncement',
    },
    primaryColor: '#E6BC7B',
    gradientColors: ['#FFE5C0', '#E6BC7B'],
    gradientCoords: { x1: '3%', y1: '8.5%', x2: '41.043%', y2: '26.738%' },
  },
  {
    name: 'gst_bsc',
    displayName: 'Green Satoshi Token',
    decimals: 8,
    ticker: 'GSTBSC',
    displayTicker: 'GST',
    addresses: { current: '0x4a2c860cEC6471b9F5F5a336eB4F38bb21683c98' },
    tokenType: 'BEP20',
    info: {
      description:
        'The Green Satoshi Token is used as currency in the gamified lifestyle app STEPN, where players can earn GST by being physically active. GST is used for repairing, upgrading, and minting NFT Sneakers in STEPN.',
      reddit: 'https://www.reddit.com/r/StepN/',
      twitter: 'https://twitter.com/Stepnofficial',
      website: 'https://www.stepn.com/',
      telegram: 'https://t.me/STEPNannouncement',
    },
    primaryColor: '#ABA3B1',
    gradientColors: ['#ABA3B1', '#ECE1F2'],
    gradientCoords: { x1: '3%', y1: '8.498%', x2: '41.043%', y2: '26.736%' },
  },
  {
    name: 'high_bsc_1204b987',
    displayName: 'Highstreet',
    displayTicker: 'HIGH',
    ticker: 'HIGHbsc1204B987',
    tokenType: 'BEP20',
    decimals: 18,
    addresses: { current: '0x5f4bde007dc06b867f86ebfe4802e34a1ffeed63' },
    info: {
      description:
        'HIGH is the token that powers Highstreet, a play-to-earn metaverse that connects gaming, shopping, and more. Products for sale can be digital like NFTs, but also physical like T-shirts.',
      website: 'https://www.highstreet.market/',
      twitter: 'https://twitter.com/highstreetworld',
      telegram: 'https://t.me/highstreetworld',
    },
    primaryColor: '#00F2FE',
    gradientColors: ['#30A6FC', '#00F2FE'],
    gradientCoords: { x1: '0%', y1: '0%', x2: '100%', y2: '100%' },
  },
  {
    name: 'inj_bsc_47753064',
    displayName: 'Injective',
    decimals: 18,
    ticker: 'INJbsc47753064',
    displayTicker: 'INJ',
    addresses: { current: '0xa2b726b1145a4773f68593cf171187d8ebe4d495' },
    tokenType: 'BEP20',
    info: {
      description:
        'INJ is the native token for Injective, a network that supports the creation of interoperable, decentralized apps. The network is governed by INJ holders, who vote on upgrades and new listings.',
      reddit: 'https://reddit.com/r/injective',
      twitter: 'https://twitter.com/Injective_',
      website: 'https://injective.com/',
    },
    primaryColor: '#0082FA',
    gradientColors: ['#0082FA', '#01B8FC'],
    gradientCoords: { x1: '0%', y1: '0%', x2: '100%', y2: '100%' },
  },
  {
    name: 'iota_bsc_32b417ef',
    displayName: 'IOTA',
    decimals: 6,
    ticker: 'IOTAbsc32B417EF',
    displayTicker: 'MIOTA',
    addresses: { current: '0xd944f1D1e9d5f9Bb90b62f9D45e447D989580782' },
    tokenType: 'BEP20',
    info: {
      description:
        'MIOTA is the token that powers IOTA, a distributed ledger that uses proprietary tech called Tangle and validates transactions made between Internet-of-Things devices.',
      reddit: 'https://reddit.com/r/Iota',
      twitter: 'https://twitter.com/iota',
      website: 'https://www.iota.org/',
    },
    primaryColor: '#00E0CA',
    gradientColors: ['#0DA89F', '#00E0CA'],
    gradientCoords: { x1: '3%', y1: '8.4%', x2: '41.04%', y2: '26.7%' },
  },
  {
    name: 'iotx_bsc_3d250dac',
    displayName: 'IoTeX',
    decimals: 18,
    ticker: 'IOTXbsc3D250DAC',
    displayTicker: 'IOTX',
    addresses: { current: '0x9678E42ceBEb63F23197D726B29b1CB20d0064E5' },
    tokenType: 'BEP20',
    info: {
      description:
        'The IoTeX token is used for payments, staking, and governance on the IoTeX network, which connects smart home devices, autonomous vehicles, and other Internet-of-Things tech to the blockchain.',
      reddit: 'https://reddit.com/r/IoTex',
      twitter: 'https://twitter.com/iotex_io',
      website: 'https://www.iotex.io/',
      telegram: 'https://t.me/IoTeXGroup',
    },
    primaryColor: '#44FFB2',
    gradientColors: ['#2ABC80', '#44FFB2'],
    gradientCoords: { x1: '3%', y1: '8.4%', x2: '41.04%', y2: '26.7%' },
  },
  {
    name: 'lina_bsc_e410b173',
    displayName: 'Linear Finance',
    decimals: 18,
    ticker: 'LINAbscE410B173',
    displayTicker: 'LINA',
    addresses: {
      current: '0x762539b45A1dCcE3D36d080F74d1AED37844b878',
    },
    tokenType: 'BEP20',
    info: {
      description:
        'LINA is the utility and governance token for the Linear Finance ecosystem, a cross-chain, delta-one asset protocol with DeFi products including Linear Buildr, Swap, Exchange, Vault, and DAO.',
      reddit: 'https://reddit.com/r/LinearFinance/',
      twitter: 'https://twitter.com/LinearFinance',
      website: 'https://linear.finance',
    },
    primaryColor: '#5067FF',
    gradientColors: ['#1A38F8', '#5067FF'],
    gradientCoords: { x1: '0%', y1: '0%', x2: '100%', y2: '100%' },
  },
  {
    name: 'ltc_bsc_2a538e9a',
    displayName: 'Litecoin',
    decimals: 18,
    ticker: 'LTCbsc2A538E9A',
    displayTicker: 'LTC',
    addresses: {
      current: '0x4338665CBB7B2485A8855A139b75D5e34AB0DB94',
    },
    info: {
      description:
        "Litecoin is a cryptocurrency similar to Bitcoin. The goal of Litecoin is to provide fast transaction confirmations. Created by ex-Google employee Charlie Lee, Litecoin is often considered the silver to Bitcoin's gold.",
      reddit: 'https://www.reddit.com/r/litecoin/',
      twitter: 'https://twitter.com/LitecoinProject',
      website: 'https://litecoin.com/',
    },
    primaryColor: '#D6D6D6',
    gradientColors: ['#D6D6D6', '#777777'],
    gradientCoords: { x1: '11.224%', y1: '-66.682%', x2: '141.81%', y2: '91.487%' },
    tokenType: 'BEP20',
  },
  {
    name: 'matic_bsc_4cef25c8',
    displayName: 'Matic',
    decimals: 18,
    ticker: 'MATICbsc4CEF25C8',
    displayTicker: 'MATIC',
    addresses: {
      current: '0xCC42724C6683B7E57334c4E856f4c9965ED682bD',
    },
    info: {
      description:
        'Polygon (previously Matic Network) is a protocol and a framework for building and connecting Ethereum-compatible blockchain networks. Aggregating scalable solutions on Ethereum supporting a multi-chain Ethereum ecosystem.',
      reddit: 'https://www.reddit.com/r/0xPolygon/',
      twitter: 'https://twitter.com/0xPolygon',
      website: 'https://polygon.technology/',
      telegram: 'https://t.me/polygonofficial',
    },
    primaryColor: '#9962f6',
    gradientColors: ['#5A63B8', '#C86DD7'],
    gradientCoords: { x1: '19.031%', y1: '-66.682%', x2: '123.324%', y2: '91.487%' },
    tokenType: 'BEP20',
  },
  {
    name: 'mbox_bsc',
    displayName: 'MoBox',
    decimals: 18,
    ticker: 'MBOXBSC',
    displayTicker: 'MBOX',
    addresses: { current: '0x3203c9E46cA618C8C1cE5dC67e7e9D75f5da2377' },
    tokenType: 'BEP20',
    info: {
      description:
        'MoBox is a player-owned platform on the BNB Smart Chain that brings DeFi and NFTs together in a play-to-earn gaming ecosystem. From yield farming to using the same NFT in multiple games at once, MoBox allows players to explore the Metaverse in new ways.',
      twitter: 'https://twitter.com/MOBOX_Official',
      website: 'https://www.mobox.io',
    },
    primaryColor: '#4676F3',
    gradientColors: ['#1949C6', '#4676F3'],
    gradientCoords: { x1: '-5%', y1: '1%', x2: '48.2%', y2: '30.3%' },
  },
  {
    name: 'mdx_bsc_d000e0cd',
    displayName: 'Mdex',
    decimals: 18,
    ticker: 'MDXbscD000E0CD',
    displayTicker: 'MDX',
    addresses: { current: '0x9C65AB58d8d978DB963e63f2bfB7121627e3a739' },
    tokenType: 'BEP20',
    info: {
      description:
        'MDX is the utility and governance token for Mdex, a cross-chain decentralized trading protocol and AMM where users can swap crypto, provide liquidity, and earn yield.',
      twitter: 'https://twitter.com/MdexTech',
      website: 'https://mdex.co',
    },
    primaryColor: '#4CA9DC',
    gradientColors: ['#2F7CA7', '#4CA9DC'],
    gradientCoords: { x1: '0%', y1: '0%', x2: '102%', y2: '101%' },
  },
  {
    name: 'near_bsc_02be202a',
    displayName: 'NEAR Protocol',
    decimals: 18,
    ticker: 'NEARbsc02BE202A',
    displayTicker: 'NEAR',
    addresses: { current: '0x1Fa4a73a3F0133f0025378af00236f3aBDEE5D63' },
    tokenType: 'BEP20',
    info: {
      description:
        'NEAR is a community-powered platform that uses Nightshade technology and supports up to 100,000 transactions per second with almost zero fees. Human-readable addresses, simple registration flows, and modular components make it user-friendly for both users and developers.',
      twitter: 'https://twitter.com/NEARProtocol',
      website: 'https://near.org/',
      telegram: 'https://t.me/cryptonear',
    },
    primaryColor: '#698BF2',
    gradientColors: ['#698BF2', '#B9CAFD'],
    gradientCoords: { x1: '3%', y1: '8.4%', x2: '41.04%', y2: '26.7%' },
  },
  {
    name: 'pancakeswap',
    displayName: 'PancakeSwap',
    decimals: 18,
    ticker: 'CAKE',
    addresses: { current: '0x0e09fabb73bd3ade0a17ecc321fd13a19e81ce82' },
    tokenType: 'BEP20',
    info: {
      description:
        'CAKE is the native currency of the PancakeSwap decentralized exchange. Users who stake funds on PancakeSwap are rewarded with CAKE. And everyone loves pancakes (and cake).',
      reddit: 'https://www.reddit.com/r/pancakeswap/',
      twitter: 'https://twitter.com/pancakeswap',
      website: 'https://pancakeswap.finance/',
      telegram: 'https://t.me/pancakeswap',
    },
    primaryColor: '#1FC7D4',
    gradientColors: ['#6FF5FF', '#1FC7D4'],
    gradientCoords: { x1: '119.625%', y1: '113.067%', x2: '0%', y2: '0%' },
  },
  {
    name: 'reef_bsc_d662ee25',
    displayName: 'Reef',
    decimals: 18,
    ticker: 'REEFbscD662EE25',
    displayTicker: 'REEF',
    addresses: { current: '0xF21768cCBC73Ea5B6fd3C687208a7c2def2d966e' },
    tokenType: 'BEP20',
    info: {
      description:
        'The REEF token is used for transaction fees, staking, and governance on Reef chain, an EVM-compatible network for DeFi, NFTs, and gaming. Reef chain uses next-gen technology with Nominated Proof of Stake, on-chain upgradability, libp2p networking, and more.',
      reddit: 'https://reddit.com/r/ReefDeFi',
      twitter: 'https://twitter.com',
      website: 'https://reef.io/',
      telegram: 'https://t.me/reefchain',
    },
    primaryColor: '#9560FF',
    gradientColors: ['#681CFF', '#9560FF'],
    gradientCoords: { x1: '29%', y1: '34.5%', x2: '-1%', y2: '-6.5%' },
  },
  {
    name: 'shibainu_bsc',
    displayName: 'Shiba Inu',
    decimals: 18,
    ticker: 'SHIBBSC',
    displayTicker: 'SHIB',
    addresses: { current: '0x2859e4544c4bb03966803b044a93563bd2d0dd4d' },
    tokenType: 'BEP20',
    primaryColor: '#F69C0A',
    gradientColors: ['#EAEAEA', '#FFF'],
    gradientCoords: { x1: '19.031%', y1: '-66.682%', x2: '123.324%', y2: '91.487%' },
  },
  {
    name: 'tlm_bsc_8df4c3e8',
    displayName: 'Alien Worlds',
    decimals: 4,
    ticker: 'TLMbsc8DF4C3E8',
    displayTicker: 'TLM',
    addresses: { current: '0x2222227E22102Fe3322098e4CBfE18cFebD57c95' },
    tokenType: 'BEP20',
    info: {
      description:
        'TLM is a token used for staking, governance, and gaming in Alien Worlds, a metaverse where players compete with each other, go on quests, and use NFT game items.',
      twitter: 'https://twitter.com/AlienWorlds',
      website: 'https://alienworlds.io',
    },
    primaryColor: '#EACB7D',
    gradientColors: ['#EACB7D', '#FFEDBF'],
    gradientCoords: { x1: '29%', y1: '34.5%', x2: '-1%', y2: '-6.5%' },
  },
  {
    name: 'toncoin_bsc_a76181ea',
    displayName: 'Wrapped TON Coin',
    decimals: 9,
    ticker: 'TONCOINbscA76181EA',
    displayTicker: 'TONCOIN',
    addresses: { current: '0x76A797A59Ba2C17726896976B7B3747BfD1d220f' },
    tokenType: 'BEP20',
    info: {
      description:
        'TON is a fully decentralized layer-1 blockchain designed by Telegram to onboard billions of users.',
      twitter: 'https://twitter.com/ton_blockchain',
      website: 'https://ton.org/',
      telegram: 'https://t.me/toncoin',
    },
    primaryColor: '#0088CC',
    gradientColors: ['#0088CC', '#1AB3FF'],
    gradientCoords: { x1: '29%', y1: '34.5%', x2: '-1%', y2: '-6.5%' },
  },
  {
    name: 'uni_bsc_98044f4e',
    displayName: 'Uniswap',
    decimals: 18,
    ticker: 'UNIbsc98044F4E',
    displayTicker: 'UNI',
    addresses: {
      current: '0xBf5140A22578168FD562DCcF235E5D43A02ce9B1',
    },
    info: {
      description:
        'UNI is the governance token of Uniswap, a decentralized protocol for automated liquidity provision on Ethereum.',
      reddit: 'https://www.reddit.com/r/UniSwap/',
      twitter: 'https://twitter.com/UniswapProtocol',
      website: 'https://uniswap.org/',
    },
    primaryColor: '#FF3495',
    gradientColors: ['#FC6CAB', '#FF007A'],
    gradientCoords: { x1: '0%', y1: '21.958%', x2: '214.397%', y2: '181.316%' },
    tokenType: 'BEP20',
  },
  {
    name: 'usdcoin_bsc',
    displayName: 'USDC',
    decimals: 18,
    ticker: 'USDCBSC',
    displayTicker: 'USDC',
    addresses: { current: '0x8AC76a51cc950d9822D68b83fE1Ad97B32Cd580d' },
    tokenType: 'BEP20',
    primaryColor: '#3E90E8',
    gradientColors: ['#EAEAEA', '#FFF'],
    gradientCoords: { x1: '19.031%', y1: '-66.682%', x2: '123.324%', y2: '91.487%' },
  },
  {
    name: 'usdt_bsc_ddedf0f8',
    displayName: 'Tether USD',
    decimals: 18,
    ticker: 'USDTbscDDEDF0F8',
    displayTicker: 'USDT',
    addresses: { current: '0x55d398326f99059fF775485246999027B3197955' },
    tokenType: 'BEP20',
    primaryColor: '#53AE94',
    gradientColors: ['#53AE94', '#2E9175'],
    gradientCoords: { x1: '0%', y1: '0%', x2: '102%', y2: '101%' },
  },
  {
    name: 'xvs_bsc_62e8348a',
    displayName: 'Venus',
    decimals: 18,
    ticker: 'XVSbsc62E8348A',
    displayTicker: 'XVS',
    addresses: {
      current: '0xcF6BB5389c92Bdda8a3747Ddb454cB7a64626C63',
    },
    tokenType: 'BEP20',
    info: {
      description:
        'XVS is the governance token of Venus, an algorithmic money-market platform offering permissionless loans, which are secured by over-collateralized positions. Users can mint synthetic stablecoins with the collateral they’ve provided.',
      twitter: 'https://twitter.com/VenusProtocol',
      website: 'https://venus.io/',
    },
    primaryColor: '#3A78FF',
    gradientColors: ['#3A78FF', '#739FFF'],
    gradientCoords: { x1: '0%', y1: '0%', x2: '100%', y2: '100%' },
  },
  {
    name: 'sqr_bsc_2fadeb84',
    displayName: 'Magic Square',
    decimals: 8,
    ticker: 'SQRbsc2FADEB84',
    displayTicker: 'SQR',
    addresses: {
      current: '0x2b72867c32cf673f7b02d208b26889fed353b1f8',
    },
    tokenType: 'BEP20',
    info: {
      description:
        'Magic Square is a web3 discovery & engagement platform powered by the SQR token on BNB Smart Chain',
      telegram: 'https://t.me/magicsquare_official/420103',
      twitter: 'https://twitter.com/magiclaunchpad',
      website: 'https://launchpad.magicsquare.io/',
    },
    primaryColor: '#DE0E69',
    gradientColors: ['#DE0E69', '#E54A8E'],
    gradientCoords: { x1: '0%', y1: '0%', x2: '100%', y2: '100%' },
  },
]
